<template>
  <div class="row col-md-9">
    <div class="col">
      <div class="stepBlock" :class="currentStep == 1 || currentStep > 1 ? 'currentStep' : 'stepItem'">
        <span v-if="currentStep == 1">1</span>
        <span v-if="currentStep > 1"><CIcon class="check mr-2" name="checkMark" :height="13" viewBox="0 0 32 32" /></span>
      </div>
      <div :class="currentStep == 1 || currentStep > 1 ? 'currentStepTitle' : 'stepTitle'">{{ $t("manageBalance.steps.1.title") }}</div>
    </div>
    <div class="col">
      <div class="stepBlock" :class="currentStep == 2 || currentStep > 2 ? 'currentStep' : 'stepItem'">
        <span v-if="currentStep == 2 || currentStep < 2">2</span>
        <span v-if="currentStep > 2"><CIcon class="check mr-2" name="checkMark" :height="13" viewBox="0 0 32 32" /></span>
      </div>
      <div :class="currentStep == 2 || currentStep > 2 ? 'currentStepTitle' : 'stepTitle'">{{ $t("manageBalance.steps.2.title") }}</div>
    </div>
    <div class="col">
      <div class="stepBlock" :class="currentStep == 3 || currentStep > 3 ? 'currentStep' : 'stepItem'">
        <span v-if="currentStep == 3 || currentStep < 3">3</span>
        <span v-if="currentStep > 3"><CIcon class="check mr-2" name="checkMark" :height="13" viewBox="0 0 32 32" /></span>
      </div>
      <div :class="currentStep == 3 || currentStep > 3 ? 'currentStepTitle' : 'stepTitle'">{{ $t("manageBalance.steps.3.title") }}</div>
    </div>
    <div class="col">
      <div class="stepBlock" :class="currentStep == 4 || currentStep > 4 ? 'currentStep' : 'stepItem'">
        <span v-if="currentStep == 4 || currentStep < 4">4</span>
        <span v-if="currentStep > 4"><CIcon class="check mr-2" name="checkMark" :height="13" viewBox="0 0 32 32" /></span>
      </div>
      <div :class="currentStep == 4 || currentStep > 4 ? 'currentStepTitle' : 'stepTitle'">{{ $t("manageBalance.steps.4.title") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Steps',
  props: {
    currentStep: {
      type: Number,
      default: false,
    },
  },
  methods: {},
}
</script>

<style lang="scss">
.stepItem {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 1px solid #868e96;
  color: #868e96;
  line-height: 1.7;
}

.check {
  color: #7FCFE6;
  margin-left: 7px;
}

.stepTitle {
  color: #868e96;
  margin-top: 10px;
}

.currentStep {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 1px solid #7FCFE6;
  color: #7FCFE6;
  line-height: 1.7;
}

.currentStepTitle {
  color: #7FCFE6;
  margin-top: 5px;
}

.stepBlock {
  cursor: pointer;
}
</style>
